import { useQuery } from "@tanstack/react-query";

import { listSchedules } from "@/adapters/api";
import { chartKeys } from "../utils/query-keys.ts";

const STALE_TIME = 60_000;

export interface UseConstructionScheduleParams {
	constructionId: string | undefined;
	enabled?: boolean;
}

export function useConstructionSchedule({
	constructionId,
	enabled = true,
}: UseConstructionScheduleParams) {
	return useQuery({
		queryKey: chartKeys.schedule(constructionId),
		// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
		queryFn: () => listSchedules(constructionId!),
		enabled: enabled && !!constructionId,
		staleTime: STALE_TIME,
		retry: false,
	});
}
